module.exports = __webpack_public_path__ + "img/Ribbon Icon - white.dbed6025.svg";